import DOMPurify from "dompurify";

import { server } from "../../services/config/server";
import { elipsize, shotTitle } from "../../_helpers/elipsize";

export const BlogCard = ({ blogdata, image, onClick }) => {

    return (
        <div className="blog-unit" onClick={onClick}>
            <div className="blog-title">
                {blogdata?.title.length > 50 ?
                    shotTitle(blogdata?.title) :
                    blogdata?.title
                }
            </div>
            <div className="blog-text"
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(elipsize(blogdata?.content)) }}

            />

            <div className="blog-images">
                <img
                    className="blog-poster"
                    src={`${server}/${image}`}
                />
            </div>
        </div>
    )
}